import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

import {
  loginRequestSecretString,
  loginValidateHashedSecret,
} from '@/api/authentication';
import { useWeb3React } from '@web3-react/core';

import useSignMessage from './useSignMessage';

function useAuthenticateWallet() {
  const { account } = useWeb3React();
  const signMessage = useSignMessage();

  const validateHashedSecretMutation = useMutation(loginValidateHashedSecret, {
    mutationKey: `loginValidateHashedSecret`,
    onError: (e) => {
      toast.error(`you did not log in`, {
        toastId: `validate-hash-key`,
      });
      // eslint-disable-next-line no-console
      console.error(e);
    },
    onSuccess: () => {
      toast.info(`you logged in!!`);
    },
  });

  const loginRequestMutation = useMutation(loginRequestSecretString, {
    mutationKey: `loginRequestMutation`,
    onError: (e) => {
      toast.error(`something went wrong when requesting challengeKey`, {
        toastId: `challenge-key`,
      });
      // eslint-disable-next-line no-console
      console.error(e);
    },
  });

  const requestSecret = async () => {
    try {
      const { secretString } = await loginRequestMutation.mutateAsync({
        walletAddress: account as string,
      });

      const signedString = await signMessage(secretString);
      if (!signedString) {
        throw new Error(`you must sign the message!`);
      }

      await validateHashedSecretMutation.mutateAsync({
        signed: signedString as string,
        walletAddress: account as string,
      });
    } catch (error) {
      throw new Error(`Something went wrong`);
    }
  };

  return requestSecret;
}

export default useAuthenticateWallet;
